import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    color: '#657786'
  },

  notesSection: {},

  textField: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '0.5rem'
  },

  input: {
    position: 'relative',
    border: `1px solid #C6C6C6`,
    borderRadius: '5px',
    width: '100%',
    padding: '8px 12px',
    resize: 'none',
    backgroundColor: '#F5F6F8',
    outline: 'none',
    fontSize: theme.size.sm,

    '&:focus': {
      border: `solid 1px ${theme.palette.primary.main}`,
      outline: 'none'
    },
    '&:focus-visible': {
      outline: 'none'
    },

    '&::placeholder': {
      color: '#888888 !important',
      opacity: '1 !important'
    }
  }
}))

export default useStyles
